import { useEffect, useRef } from 'react';

import { useObservability } from 'helpers/observability';

interface PropertyViewSurveyTriggerOptions {
  addressToken: string | null;
  isOpen: boolean;
}

export const usePropertyViewSurveyTrigger = ({
  addressToken,
  isOpen,
}: PropertyViewSurveyTriggerOptions) => {
  // oxlint-disable-next-line typescript/no-deprecated -- OFFER-4581: existing legacy analytics usage is tracked for removal
  const { trackEvent } = useObservability();
  const trackedAddressToken = useRef<string | null>(null);

  useEffect(() => {
    if (!isOpen || !addressToken) {
      trackedAddressToken.current = null;
      return;
    }
    if (trackedAddressToken.current === addressToken) {
      return;
    }
    trackedAddressToken.current = addressToken;
    trackEvent('property-view-sprig');
  }, [addressToken, isOpen, trackEvent]);
};
